/**
 * DECLARATION DE FUNCTIONS
 */

(function ($) {
    $.fn.fancybox_images = function (params) {
        this.each(function () {
            $("a[href$='.jpg'], a[href$='.png'], a[href$='.jpeg'], a[href$='.gif'], a[href$='.svg']").fancybox({
                keyboard: true,
                loop: false,
                arrows: true,
                infobar: false,
                afterLoad: function (instance, current) {
                    var pixelRatio = window.devicePixelRatio || 1;

                    if (pixelRatio > 1.5) {
                        current.width = current.width / pixelRatio;
                        current.height = current.height / pixelRatio;
                    }
                }
            });
        });
    };
})(jQuery)

/**
 * DOM
 */
jQuery(document).ready(function ($) {
    /**
     * FUNCTIONS
     */
    $('body').fancybox_images();

    /**
     * ANIMATIONS
     */
    //wow
    new WOW({
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
    }).init();

    /**
     * scroll on click
     */
    $('a[href^="#"]').not('.pager .page').on('click', function (event) {
        var target = this.hash;

        // ignore les liens vides ou dont la cible n'existe pas
        if (!target || !$(target).length) {
            return;
        }

        event.preventDefault();
        $('html, body').animate({scrollTop: $(target).offset().top - 150}, 400);
    });

    /**
     * document load
     */
    $(window).load(function () {

        //nav mobile foldable
        $('nav.mobile .menu-item-has-children > a').on('click', function (e) {
            e.preventDefault();
            $(this).next("ul").slideToggle();
            $(this).toggleClass("open");
        });
    });

});
